
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import {deepCopy} from "@/auxillary";
import {studyInstitutesModule, usersModule} from "@/store";
import ShortUserDto = MdbsCore.ShortUserDto;
import IStudyInstituteCreateDto = MdbsCore.IStudyInstituteCreateDto;
import StudyInstituteCreateDto = MdbsCore.StudyInstituteCreateDto;
import {rules} from "@/auxillary/rules";

@Component({})
export default class StudyInstituteCreateDialog extends Vue {
  @Prop({required: true})
  institute!: IStudyInstituteCreateDto;

  currentInstitute: IStudyInstituteCreateDto = new StudyInstituteCreateDto();

  country: any = null;
  countries = [
    {
      "displayName": "Deutschland",
      "value": "germany"
    },
    {
      "displayName": "Österreich",
      "value": "austria"
    }
  ]

  saving = false;
  valid: boolean = false;
  rules: any = rules;

  get allUsers() {
    return usersModule.users;
  }

  get usersLoading() {
    return usersModule.isLoading;
  }

  getUserName(user: ShortUserDto) {
    return user.userName + " - " + user.displayName
  }

  @Watch('institute', {immediate: true})
  async onInstituteChange(institute: IStudyInstituteCreateDto | null) {
    if (institute == null) {
      return;
    }

    this.currentInstitute = deepCopy(institute);
    this.country =  this.currentInstitute.additionalInfo?.country;

    Vue.nextTick(() => {
      this.form.validate();
    });
    await usersModule.loadAll();
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  async save() {
    try {
      this.saving = true;
      if (this.currentInstitute.maxPatientsCount !== undefined) {
        this.currentInstitute.maxPatientsCount = Number.parseInt(this.currentInstitute.maxPatientsCount?.toString());
      }

      if (this.currentInstitute.additionalInfo == undefined)
        this.currentInstitute.additionalInfo = {};
      this.currentInstitute.additionalInfo.country = this.country ?? "";

      await studyInstitutesModule.createStudyInstitute(this.currentInstitute);

      this.$emit('save');
    } finally {
      this.saving = false;
    }
  }

  async cancel() {
    this.$emit('cancel');
  }
}
